import { useEffect,useState } from 'react';
import { callApi } from '../utils/apiClient';
import { API_ENDPOINTS } from '../config/api/apiCall';


// export default function useEmployeeStatusList(
//     isLoaded,
//     setEmployeeStatus,
//     setSelectedEmployeeStatus,
//     setEmployeeStatusID,
//     handleMessage,
//     setIsEmployeeStatusLoaded
// ) {
//     useEffect(() => {
//         if (!isLoaded) {
//             const para = {
//                 p_companyid: localStorage.getItem('companyid'),
//             };

//             callApi(API_ENDPOINTS.MASTER_GET_EMPLOYEE_STATUS, 'POST', { 'Content-Type': 'application/json' }, para)
//                 .then(data => {
//                     if (Array.isArray(data) && data.length > 0) {
//                         setEmployeeStatus(data);
//                         setSelectedEmployeeStatus(data[0]);
//                         setEmployeeStatusID(data[0].id);
//                         setIsEmployeeStatusLoaded(true);
//                     } else {
//                         setEmployeeStatus([]);
//                     }
//                 })
//                 .catch(error => {
//                     handleMessage('error', error.message, 'Error');
//                 });
//         }
//     }, [isLoaded, setEmployeeStatus, setSelectedEmployeeStatus, setEmployeeStatusID, handleMessage]);
// }


const useEmployeeStatusList = ({ editID, handleMessage }) => {
    const [isLoad, setIsLoad] = useState(false);
    const [employeeStatus, setEmployeeStatus] = useState([]);
    const [selectedEmployeeStatus, setSelectedEmployeeStatus] = useState(null);
    const [employeeStatusID, setEmployeeStatusID] = useState(0);

    // ✅ Async fetch function
    const fetchEmployeeStatusList = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await callApi(
                API_ENDPOINTS.MASTER_GET_EMPLOYEE_STATUS,
                "POST",
                { "Content-Type": "application/json" },
                para
            );

            if (Array.isArray(data) && data.length > 0) {
                setEmployeeStatus(data);

                const initialDesignation = data.find((dept) => dept.id === selectedID);

                if (initialDesignation) {
                    setSelectedEmployeeStatus(initialDesignation);
                    setEmployeeStatusID(initialDesignation.id);
                }
            } else {
                setEmployeeStatus([]);
            }

            setIsLoad(true);
        } catch (error) {
            handleMessage("error", error.message || "Something went wrong", "Error");
        }
    };

    // ✅ Proper useEffect
    useEffect(() => {
        if (!isLoad && editID === 0) {
            fetchEmployeeStatusList();
        }
    }, [isLoad, editID]);

    // ✅ Public loader
    const loadEmployeeStatusByID = async (selectedID) => {
        await fetchEmployeeStatusList(selectedID);
    };

    return {
        employeeStatus,
        selectedEmployeeStatus,
        employeeStatusID,
        setEmployeeStatus,
        setSelectedEmployeeStatus,
        setEmployeeStatusID,
        loadEmployeeStatusByID,
    };
};

export default useEmployeeStatusList;
